export const CLOSE_ERROR_POPUP = 'CLOSE_ERROR_POPUP';
export type CLOSE_ERROR_POPUP = typeof CLOSE_ERROR_POPUP;

export const SHOW_ERROR_UPDATE_MESSAGE = 'SHOW_ERROR_UPDATE_MESSAGE';
export type SHOW_ERROR_UPDATE_MESSAGE = typeof SHOW_ERROR_UPDATE_MESSAGE;


// WEBPACK FOOTER //
// ./src/store/Errors/constant.ts